module.exports = __webpack_public_path__ + "static/media/Architecture_26.01e32ae0.jpg";